import { ProfileHoursTranslations } from './profile-hours.translations.model';
import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { ProfileHoursHoursdata } from './profile-hours.hoursdata.interface';

@Component({
  selector: 'platform-profile-hours',
  templateUrl: './profile-hours.component.html',
  styleUrls: ['./profile-hours.component.scss'],
})
export class ProfileHoursComponent implements OnChanges, OnInit {
  @Input() public hoursdata: ProfileHoursHoursdata;
  @Input() public translations: ProfileHoursTranslations =
    new ProfileHoursTranslations();

  ngOnInit() {
    this.includeFormattedDay();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['hoursdata'] || changes['translations']) {
      this.includeFormattedDay();
    }
  }

  private includeFormattedDay(): void {
    if (this.hoursdata && this.hoursdata.days) {
      this.hoursdata.days.forEach((day) => {
        let hours = day.hours;
        if (hours.match(/\d{2}:\d{2}\s*-\s*\d{2}:\d{2}/)) {
          hours = hours.replace(/:/g, '');
        }
        if (hours.match(/\d{4}\s*(-|:)\s*\d{4}/)) {
          const split = hours.split(/:|-/);
          day.formatted =
            split[0] === split[1]
              ? this.translations.allDay
              : this.formatTime(split[0]) + ' - ' + this.formatTime(split[1]);
        } else {
          day.formatted = day.hours;
        }
      });
    }
  }

  private formatTime(time: string) {
    let hours = parseInt(time.substr(0, 2), 10);
    const minutes = time.substr(2, 2);
    const ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    return hours + ':' + minutes + ampm;
  }
}
